import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import DepthAndRogWeightages from "./Utils/DepthAndRogWeightages";
import SalesPrediction from "./Utils/SalesPrediction";
import showFloatToPercentage from "./Utils/showFloatToPercentage";

const cellBorder = 'border-[0.5px] border-slate-600 text-center '


const DemandForecastTable = ({ trends, demandForecastType, salesTarget, setShowImagesPopup, NATrends, olderTrends, olderNATrends }) => {

  const [displayTrends, setDisplayTrends] = useState([])
  const userLoggedIn = useSelector(state => state.userLoggedIn);


  const onClickHandler = (trend) => {
    setShowImagesPopup({ tag: trend.trendTag, value: trend.trendValue, trendType: 'social' })
  };

  useEffect(() => {
    const { ROG, depth } = DepthAndRogWeightages(demandForecastType)

    let targetTrendsResult = SalesPrediction(trends, NATrends, depth, ROG, salesTarget)
    const oldTargetTrendsResult = SalesPrediction(olderTrends, olderNATrends, depth, ROG, salesTarget)
    //100% depth weightage
    const currentTrendsResult = SalesPrediction(trends, NATrends, 1, 0, salesTarget)

    const olderTrendsObj = {};
    oldTargetTrendsResult.forEach(t => {
      olderTrendsObj[t.value] = t
    })


    const currentTrendsObj = {};
    currentTrendsResult.forEach(t => {
      currentTrendsObj[t.value] = t
    })


    targetTrendsResult.forEach(trend => {
      if (currentTrendsObj[trend.value]) {
        trend.currentSales = currentTrendsObj[trend.value].sales
        trend.currentScore = currentTrendsObj[trend.value].score
      }
      if (olderTrendsObj[trend.value]) {
        trend.oldSales = olderTrendsObj[trend.value].sales
        trend.oldScore = olderTrendsObj[trend.value].score
      }
      trend.todayForecastSales = trend.sales
      trend.todayForecastScore = trend.score
      trend.successRate = Math.max(0, Math.round(100 - (Math.abs(trend.currentSales - trend.oldSales) / trend.currentSales) * 100) / 100)
      trend.missedDemand = (trend.currentSales - trend.oldSales) / trend.currentSales
    })

    //    targetTrendsResult = targetTrendsResult.filter(t => t.value != "#N/A")
    setDisplayTrends(targetTrendsResult)
  }, [trends, demandForecastType, salesTarget, olderTrends, olderNATrends])


  return <><div className="w-full h-[30rem] flex overflow-y-auto justify-start border-b border-b-slate-500 ">
    <table className="border border-separate border-spacing-0">
      <thead>
        <tr className="max-h-8 bg-slate-200 sticky top-0">
          <th className={cellBorder + ' border-r-2 w-1/5 '}></th>
          <th className={cellBorder + ' w-1/5'}>
            <div>Demand Forecast made on {dayjs(new Date()).subtract(45, 'd').format('DD MMMM')}</div>
          </th>
          <th className={cellBorder + ' w-1/5'}>Reality between {dayjs(new Date()).subtract(45, 'd').format('DD MMMM')}-{dayjs(new Date()).format('DD MMMM')}</th>
          <th className={cellBorder + ' border-r-4 border-r-black ' + ' w-1/5'}>{dayjs(new Date()).subtract(45, 'd').format('DD MMMM')}'s Forecast Accuracy</th>
          <th className={cellBorder + ' w-1/5'}>Demand Forecast for next 45 Days</th>
        </tr>
      </thead>
      <tbody>
        {
          displayTrends.map(trend => (userLoggedIn.curator || trend.successRate > 0 ? <tr key={trend.value} onClick={() => {
            onClickHandler(trend)
          }}>
            <td className={cellBorder + ' border-r-2 bg-slate-200 font-semibold'}>{trend.value == '#N/A' ? trend.tag + ' not applicable' : trend.value}</td>
            <td className={cellBorder}>
              {false ? <div>{trend.oldSales || 0} quantities</div> : null}
              <div><span className="font-semibold">{trend.oldScore ? showFloatToPercentage(trend.oldScore) : 0}%</span>  of total</div>
            </td>
            <td className={cellBorder}>
              {false ? <div>{trend.currentSales} quantities</div> : null}
              <div><span className="font-semibold">{showFloatToPercentage(trend.currentScore)}%</span>  of total</div>
            </td>
            <td className={cellBorder + ' border-r-4 border-r-black '}>
              <div>{showFloatToPercentage(trend.successRate, 2)}% accurate prediction</div>
              <div className="text-gray-400 ">{trend.missedDemand > 0 ? "Missed" : "Overshot"} {showFloatToPercentage(Math.abs(trend.missedDemand))}%</div>
            </td>
            <td className={cellBorder + 'bg-green-100'}>
              <div>{showFloatToPercentage(trend.todayForecastScore)}%  of total</div>
              <div>({trend.todayForecastSales} quantities)</div>
            </td>
          </tr> : null))
        }
      </tbody>
    </table>
  </div>
  </>

}

export default DemandForecastTable
